
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "ownformlist",
	init: init,
	uninit: uninit,
	listeners: listeners,
	refresh: refresh,
	_group: null,
	_group_tracker: null,
});

function init() {
	this._rawForms = [];
	this._group_tracker = this.dispatcher.createTracker();
	this.refresh();
	this.push({});
}

function uninit() {
	this._group_tracker.off();
	this._group_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/forms/group/removed": refresh,
		"mqtt:$/forms/group/added": refresh,
		"orggroup:updated": handle_org_group_update,
		"mqtt:$/org/user/requests/in/accepted": refresh,
		"mqtt:$/org/user/removed": clean_form,
	};
}

function handle_org_group_update(group){
	if(!group) return;
	if(this._group === group) return;
	var tracker = this._group_tracker;
	tracker.off();
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/created", handle_definition_created.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/updated", handle_definition_updated.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/removed", handle_definition_removed.bind(this));
}

function clean_form() {
	this.push({});
}

function refresh() {
	this.emit("save:trigger:start");
	return this.api.forms.list.own() // Get the forms list
		.then(set_forms.bind(this)) // Set _forms on the store
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function set_forms(forms) {
	this._rawForms = forms;
	this.push(makeMap(forms));
}

function handle_definition_created(definition){
	var rawForms = this._rawForms;
	var newForms = makeMap(rawForms.concat(definition));
	this.push(newForms);
}

function handle_definition_updated(definition){
	var rawForms = this._rawForms;
	var updated = rawForms.map((form) => {
		if(form._id === definition._id)
			return xtend(form, definition);
		return form;
	});

	var newForms = makeMap(updated);
	this.push(newForms);
}

function handle_definition_removed(definition){
	var rawForms = this._rawForms;
	var removed = rawForms.filter(form => form._id !== definition._id);

	var newForms = makeMap(removed);
	this.push(newForms);
}

function makeMap(arr){
	return arr.reduce((a, e) => {
		a[e._id] = e;
		return a;
	}, {});
}